import dayjs from 'dayjs';
import Linkable from '@/components/common/linkable';
import { HighlightKeyword } from '@/components/search/search-list-item';
import type { SearchMessageResult } from '@/hooks/search/use-search-messages';
import ROUTES from '@/routes';
import { parseSessionKey } from '@/utils/session';
import { AvatarWithStatus } from '../common/avatar-with-status';

type Props = {
  result: SearchMessageResult[];
  sessionKey: string;
  keyword: string;
};

export default function ConversationSearchResult({ result, sessionKey, keyword }: Props) {
  const [type, id] = parseSessionKey(sessionKey);
  const [{ SearchResultDetails: resultDetails = [] } = {}] = result;

  return resultDetails.map(({ Id: messageId, HeaderImg, NickName, Message, CreateTime }) => (
    <Linkable
      key={messageId}
      to={
        id
          ? (type === 'session' ? ROUTES.MESSAGES.SESSIONS : ROUTES.MESSAGES.GROUPS).$buildPath({
              params: { id },
              searchParams: { search: messageId },
            })
          : undefined
      }>
      <div className='flex max-w-full items-center gap-2 py-2'>
        <AvatarWithStatus
          imageUrl={HeaderImg ?? ''}
          label={NickName}
          className='size-12'
          size={[48, 48]}
          defaultAvatar={type === 'session' ? 'user' : 'group'}
        />

        <div className=' flex-1 overflow-hidden'>
          <div className='text-h2 desktop:text-h3 '>{NickName}</div>
          <p className='text-body2 desktop:text-h3'>
            <HighlightKeyword
              text={Message}
              highlight={keyword}
            />
          </p>
        </div>

        <span className='text-sm text-gray-400'>{dayjs(CreateTime).fromNow()}</span>
      </div>
    </Linkable>
  ));
}
